import { useSelector } from 'react-redux';
import { getMethod } from '../../../../utils';
import Select from '../../../Basic/Inputs/Select';

const PackagingMethodSelect = ({ method = {}, onSelect = () => {}, style = {}, width = '175px', ...props }) => {
  const methods = useSelector((store) => store.packaging);

  return (
    <Select
      select={getMethod(method, methods)}
      list={methods}
      valueFn={(pr) => pr.method}
      onSelect={(pr) => onSelect(pr)}
      width={width}
      style={style}
      {...props}
    />
  );
};

export default PackagingMethodSelect;
